import { useRecoilValue } from "recoil";
import { productKeyAtom, userInfoAtom } from "src/atoms";
import { ProductKey, ProductKeyList } from "src/config/config";
import { isDspProductList } from "src/mocks/useProductInfo";

// 제품 판별 플래그 집계 훅.
// 개별 훅(useIsOciProduct / useIsDspProduct / useIsWrapsodyProduct ...)을 여러 번
// 호출하는 대신 한 번에 파생 플래그를 얻기 위한 훅. 판정식은 기존 훅과 동일하게 유지.
//
// 주의: isOciProduct 만 데이터 소스가 다르다.
// - isOciProduct: userInfoAtom.loginType 기반(로그인/프로비저닝 컨텍스트)
// - 그 외 플래그: productKeyAtom(현재 선택된 제품) 기반
export const useProductFlags = () => {
  const productKey = useRecoilValue(productKeyAtom);
  const userInfo = useRecoilValue(userInfoAtom);

  return {
    productKey: productKey as ProductKey,
    // 로그인 타입 기반 (useIsOciProduct와 동일)
    isOciProduct: ProductKeyList.includes(userInfo?.loginType), // loginType === CLOUD면 포탈 제품 key값이면 OCI
    // 현재 선택 제품 기반
    isWrapsody: productKey === "WRAPSODY",
    isWrapsodyEco: productKey === "WRAPSODY_ECO",
    isDspProduct: isDspProductList.includes(productKey ?? ""),
    isDspmProduct: productKey === "DSPM",
    isFiresideProduct: productKey === "FIRESIDE",
    isMindSatProduct: productKey === "MIND_SAT",
  };
};
